var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.50076L10.4356 16.635C9.50889 17.509 8.252 18 6.94145 18C5.63089 18 4.37402 17.509 3.44732 16.635C2.52061 15.761 2 14.5756 2 13.3396C2 12.1035 2.52061 10.9182 3.44732 10.0442L11.0117 2.90999C11.6296 2.32733 12.4675 2 13.3412 2C14.2149 2 15.0528 2.32733 15.6706 2.90999C16.2884 3.49266 16.6355 4.28292 16.6355 5.10692C16.6355 5.93093 16.2884 6.72119 15.6706 7.30385L8.09793 14.438C7.78903 14.7294 7.37007 14.893 6.93322 14.893C6.49637 14.893 6.07741 14.7294 5.76851 14.438C5.45961 14.1467 5.28607 13.7516 5.28607 13.3396C5.28607 12.9276 5.45961 12.5324 5.76851 12.2411L12.7567 5.65809",
    stroke: "#048FAD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClip);
export default __webpack_public_path__ + "static/media/icon-clip.abf9f4d92560a17315120f985e084b49.svg";
export { ForwardRef as ReactComponent };